import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Separator = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: ${props => props.theme.stroke.default};
    background-color: ${props => props.theme.colors.border.subtle};
  }
`

export const AddButtonRow = styled.div`
  display: flex;
`
